module.exports = __webpack_public_path__ + "static/media/TDEM_logo.7058c63e.png";